import React, { useEffect, useState } from "react";
import { Grid2 as Grid, Table, TableBody, TableContainer, TableHead, TableRow, Paper, Checkbox, FormControlLabel } from '@mui/material';
import { postData } from "../func/api";
import { SmallCell, CheckboxCell } from "../style/tablecell";
import { TypographyNomalBold, TypographyBold } from '../style/typography';

export default function ContactList({ title, contactList, onCheckedChange }) {

    return (
        <Grid size={12}>
            <TypographyBold sx={{ mt: 4 }}>{title}</TypographyBold>
            <TableContainer component={Paper} sx={{ maxHeight: 700, overflowX: "auto", mt: 2 }}>
                <Table stickyHeader sx={{ tableLayout: "auto", minWidth: "100%" }}>
                    <TableHead>
                        <TableRow>
                            <SmallCell><TypographyNomalBold>対象発電所</TypographyNomalBold></SmallCell>
                            <SmallCell><TypographyNomalBold>会社名</TypographyNomalBold></SmallCell>
                            <SmallCell><TypographyNomalBold>優先順位1_氏名</TypographyNomalBold></SmallCell>
                            <SmallCell><TypographyNomalBold>優先順位1_電話番号</TypographyNomalBold></SmallCell>
                            <SmallCell><TypographyNomalBold>優先順位2_氏名</TypographyNomalBold></SmallCell>
                            <SmallCell><TypographyNomalBold>優先順位2_電話番号</TypographyNomalBold></SmallCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {contactList.map((row, index) => {
                            const key = row.facility_uuid || index;
                            return (
                                <TableRow key={key}>
                                    <SmallCell>{row.facility_names}</SmallCell>
                                    <SmallCell>{row.company_name}</SmallCell>
                                    <SmallCell>{row.person1_name}</SmallCell>
                                    <SmallCell>{row.person1_tel || ""}</SmallCell>
                                    <SmallCell>{row.person2_name}</SmallCell>
                                    <SmallCell>{row.person2_tel || ""}</SmallCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
}